import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset } from 'redux-form';
import { actions as documentOutputActions, selectors as documentOutputSelectors } from 'ducks/documentOutput';
import PrintDialog from './PrintDialog';
import { IApplicationState } from 'ducks/reducers';

const makeMapStateToProps = () => (state: IApplicationState, ownProps: { documentType: string; fieldId: string; formName?: string }) => {
  const { documentType, fieldId } = ownProps;

  return {
    printOutputOptions: documentOutputSelectors.options(documentType, fieldId)(state),
    dirty: isDirty('PrintForm')(state),
    values: getFormValues('PrintForm')(state),
    isValid: isValid('PrintForm')(state),
  };
};

const makeMapDispatchToProps = () => (dispatch: Dispatch, ownProps: { documentType: string; fieldId: string; formName?: string }) => {
  const { documentType, fieldId } = ownProps;

  return bindActionCreators(
    {
      resetForm: () => reset('PrintForm'),
      clearPrintOutputOptions: () => documentOutputActions.clearInitialOptions(documentType, fieldId),
      setPrintOutputOptions: (options) => documentOutputActions.updateInitialOptions(documentType, fieldId, options),
    },
    dispatch
  );
};

export default connect(makeMapStateToProps, makeMapDispatchToProps)(PrintDialog);
